import { Modal } from "flowbite-react";
import { useState } from "react";
import ChangePlanModal from "./formsModal/ChangePlanModal";
import CancelPlanModal from "./formsModal/CancelPlanModal";
import ChangeVehicleModal from "./formsModal/ChangeVehicleModal";
import RenewPlanModal from "./formsModal/RenewPlanModal";
import { FormikProvider, useFormik } from "formik";
import { IRenter, RENTER_STATUS } from "../../../../../../types/renter.type";
import AdditionsPlan from "./formsModal/AdditionsPlan";
import FinishedPlanModal from "./formsModal/FinishedPlanModal";
import ButtonWithLoader from "../../../../../../common/components/ui/loading/ButtonLoading";
import { IVehicleVisualRecord } from "../../../../../../types/vehicle-visual-record.type";
import ReactivatePlan from "./formsModal/ReactivatePlanModal";
import { differenceInDays } from "date-fns";
import { InfoPlanRenter } from "./formsModal/field/InfoPlanRenter";
import UnfreezePlan from "./formsModal/UnfreezePlan";
import { FiInfo, FiSettings, FiChevronDown } from "react-icons/fi";

type Props = {
  onClose: () => void;
  data: IRenter;
  register: IVehicleVisualRecord[];
  vehicleId: string;
  reuturnReason: string;
};

export function EditBond(props: Props) {

  const initialRegisters = [
    { type: 'Frente do veículo', content: '' },
    { type: 'Lateral direita do veículo', content: '' },
    { type: 'Lateral esquerda do veículo', content: '' },
    { type: 'Traseira do veículo', content: '' },
    { type: 'Odômetro', content: '' },
  ];
  const [selectedOption, setSelectedOption] = useState('');
  const renter = props.data;
  const today = new Date(); // Obtenha a data atual no formato YYYY-MM-DD
  const register = props.register?.[0]?.photos?.devolutionPhotos ?? initialRegisters;
  const returnReason = props.reuturnReason ? props.reuturnReason : "";
  const vehicleId = renter.activationData?.vehicle.id
    ? renter.activationData?.vehicle.id
    : props.vehicleId;

  const vehicleHistory = renter?.desactivationData?.vehicleHistory;
  let licensePlate;
  let cancelDate;
  let optionRepossesion;
  let repossessionDate;

  if (
    renter.status != RENTER_STATUS.Ativo &&
    vehicleHistory &&
    vehicleHistory.length > 0
  ) {
    licensePlate = vehicleHistory[vehicleHistory.length - 1].licensePlate;
    cancelDate = vehicleHistory[vehicleHistory.length - 1].vehicleHistoryEnd;
    repossessionDate = vehicleHistory[vehicleHistory.length - 1].vehicleHistoryEnd;
    optionRepossesion = vehicleHistory[vehicleHistory.length - 1].optionRepossesion;
  }

  licensePlate = renter.activationData?.vehicle.licensePlate
    ? renter.activationData?.vehicle.licensePlate
    : licensePlate;

  const planName = renter.activationData?.plan.label;
  const isSvRecisionOnly =
    planName?.includes("SV") &&
    optionRepossesion != "VEHICLE_EXCHANGE" &&
    renter.status === RENTER_STATUS.WaitingRescision;

  const differeceDays = differenceInDays(new Date(), new Date(cancelDate)) - 10;


  const formik = useFormik({
    initialValues: {
      renterId: renter._id,
      renterName: renter.name,
      licensePlate: licensePlate,
      vehicle: {
        _id: vehicleId,
      },
      reason: "",
      optionRepossesion: optionRepossesion ? optionRepossesion : "",
      registers: register.length > 0 ? register : initialRegisters,
      returnReason: returnReason,
      period: {
        value: "",
        label: "",
        months: 0,
      },
      additions: [],
      subscriptionInitialDate: today,
    },
    onSubmit: async (data) => {
      data;
    },
  });

  const handleCloseModal = () => {
    props.onClose();
  };
  const isDisabled =
    !planName ||
    (renter.status === RENTER_STATUS.Recall &&
      differeceDays > 0 &&
      differeceDays < 10);

  const showReactivatePlan =
    renter.status === "recolhimento" ||
    renter.status === "recision" ||
    renter.status === "finished";

  const DateCancelCalculate = cancelDate ? cancelDate : new Date();
  const daysRemaining = Math.abs(
    differenceInDays(
      DateCancelCalculate,
      renter.activationData?.plan.subscriptionEndDate
    )
  );

  return (
    <Modal
      className='relative text-black dark:text-black'
      size={'5xl'}
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='h-12 items-center text-black'>
        <h2 className="dark:text-black">Editar Plano do cliente: {renter.name}</h2>
      </Modal.Header>
      <Modal.Body
        className='flex flex-col dark:bg-gray-800'
        style={{ minHeight: 'auto' }}>
        <FormikProvider value={formik}>
          <div >
            <h3 className="font-medium text-gray-600 dark:text-gray- flex items-center gap-2">
              <FiInfo className="text-yellow-500" />
              Plano Atual
            </h3>
            <InfoPlanRenter
              planLabel={renter?.activationData?.plan?.label}
              daysRemaining={daysRemaining}
              initialDateRented={renter.activationData?.activationDate}
              firstInstallmentDate={
                renter.activationData?.plan?.subscriptionInitialDate
              }
              endDate={renter.activationData?.plan.subscriptionEndDate}
              weeklyValue={renter.activationData.plan.value}
            />
          </div>

          {/* Seção de Ações */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2">
              <FiSettings className="text-blue-500" />
              Selecione a ação desejada:
            </h3>

            <div className="relative">
              <select
                className="w-full p-3 pl-10 text-lg bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                onChange={(e) => setSelectedOption(e.target.value)}
                value={selectedOption}
              >
                <option value="">Selecione uma opção...</option>
                <option
                  value="changePlan"
                  disabled={isDisabled || isSvRecisionOnly}
                >
                  Trocar/Migrar plano
                </option>
                <option
                  value="renewPlan"
                  disabled={isDisabled || isSvRecisionOnly}
                >
                  Renovar Plano
                </option>
                {/* Esta opção mantém sua lógica original, pois é a única que deve ficar ativa */}
                <option value="cancelPlan" disabled={!planName}>
                  Cancelar Plano
                </option>
                <option
                  value="fineshedPlan"
                  disabled={!planName || isSvRecisionOnly}
                >
                  Finalizar Plano
                </option>
                <option
                  value="unfreezePlan"
                  disabled={
                    renter.status !== RENTER_STATUS.Congelado ||
                    isSvRecisionOnly
                  }
                >
                  Descongelar Plano
                </option>
                <option
                  value="additionsPlan"
                  disabled={isDisabled || isSvRecisionOnly}
                >
                  Serviços Adicionais
                </option>
                <option
                  value="changeVehicle"
                  disabled={isDisabled || isSvRecisionOnly}
                >
                  Trocar Moto/Moto Reserva
                </option>
                {showReactivatePlan && differeceDays < 10 && (
                  <option
                    value="reactivatePlan"
                    disabled={differeceDays > 10 || isSvRecisionOnly}
                  >
                    Reativar Plano
                  </option>
                )}
              </select>
              <FiChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
          </div>

          {/* Conteúdo Dinâmico */}
          {selectedOption && (
            <div className="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 animate-fadeIn">
              {selectedOption === "changePlan" && (
                <ChangePlanModal {...props.data} />
              )}
              {selectedOption === "renewPlan" && (
                <RenewPlanModal data={props.data} />
              )}
              {selectedOption === "cancelPlan" && (
                <CancelPlanModal
                  data={props.data}
                  vehicleId={props.vehicleId}
                  daysRemaining={daysRemaining}
                  repossessionDate={repossessionDate}
                />
              )}
              {selectedOption === "fineshedPlan" && (
                <FinishedPlanModal
                  data={props.data}
                  vehicleId={props.vehicleId}
                  daysRemaining={daysRemaining}
                />
              )}
              {selectedOption === "additionsPlan" && (
                <AdditionsPlan data={props.data} />
              )}
              {selectedOption === "unfreezePlan" && (
                <UnfreezePlan data={props.data} />
              )}
              {selectedOption === "changeVehicle" && (
                <ChangeVehicleModal data={props.data} />
              )}
              {selectedOption === "reactivatePlan" && (
                <ReactivatePlan data={props.data} />
              )}
            </div>
          )}
        </FormikProvider>
      </Modal.Body>
      <Modal.Footer className="flex justify-end h-16 pb-8">
        <ButtonWithLoader type="button" onClick={handleCloseModal}>
          Fechar
        </ButtonWithLoader>
      </Modal.Footer>
    </Modal >
  );
}
